<template>
  <div
    class="position-absolute w-100 h-100 overflow-hidden top-0 left-0 video-bg-container"
    :class="{'auto-ratio-wrapper': options.autoRatio}"
  >
    <div
      ref="videoContainer"
      class="hs-video-bg-video"
    >
      <iframe
        ref="videoElement"
        :src="videoUrl"
        frameborder="0"
        loading="lazy"
        class="embed-responsive-item"
        allow="accelerometer; autoplay; encrypted-media; gyroscope"
        allowfullscreen
        :style="{ pointerEvents: 'none' }"
      />
      <div class="video-overlay" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { getEmbedUrl } from '@/utils/videoEmbed'
import ResolutionMixin from '@/components/mixins/ResolutionMixin'

export default {
  name: 'BackgroundVideoV2',
  mixins: [ResolutionMixin],
  props: {
    options: {
      required: true,
      type: Object,
      default: () => ({
        url: '',
        start: '',
        ratio: 1,
        autoRatio: false
      })
    }
  },
  data () {
    return {
      ratioContainer: null
    }
  },
  computed: {
    videoUrl () {
      return getEmbedUrl(this.options.url, {
        autoplay: true,
        mute: true,
        loop: true,
        controls: false,
        start: this.getTimeCode(this.options.start),
        playsinline: true,
        disablekb: true
      })
    },
    ratio: {
      get () {
        return _.get(
          this.options,
          ['ratio', this.resolutioner],
          _.get(this.options, 'ratio.lg', this.options.ratio)
        )
      },
      set (val) {
        this.$set(
          this.options,
          'ratio',
          { ..._.set(this.options.ratio, [this.resolutioner], val) }
        )
      }
    }
  },
  watch: {
    'options.url' () {
      this.$nextTick(() => {
        this.calculateRatio()
      })
    },
    'options.ratio' () {
      this.calculateRatio()
    },
    resolutioner () {
      this.calculateRatio()
    }
  },
  methods: {
    getTimeCode (timeString) {
      if (!timeString) return 0
      const timePieces = timeString.split(':')
      return parseInt(timePieces[0] * 3600) +
          parseInt(timePieces[1] * 60) +
          parseInt(timePieces[2])
    },
    calculateRatio () {
      if (!this.$refs.videoContainer || this.options.autoRatio) return

      const containerRatio = this.ratioContainer.clientWidth / this.ratioContainer.clientHeight
      const width = (containerRatio * this.ratioContainer.clientWidth) * this.ratio + 100
      const height = (containerRatio * this.ratioContainer.clientHeight) * this.ratio

      this.$refs.videoContainer.style.width = `${width}px`
      this.$refs.videoContainer.style.height = `${height}px`
    }
  },
  mounted () {
    this.ratioContainer = this.$parent.$el
    this.calculateRatio()
    window.addEventListener('resize', this.calculateRatio)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.calculateRatio)
  }
}
</script>

<style lang="scss" scoped>
.video-bg-container {
  clip: rect(0, auto, auto, 0);

  .video-bg {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    transform: translate(-50%, -50%);

    iframe {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 0;
    }
  }

  .video-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
}

.auto-ratio-wrapper {
  iframe {
    width: 100vw;
    height: 56.25vw; /* 16:9 aspect ratio */
    min-height: 100vh;
    min-width: 177.77vh; /* 16:9 aspect ratio */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>